import * as React from 'react';
import type { SVGProps } from 'react';
const SvgExklusivleistungen = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <g clipPath="url(#exklusivleistungen_svg__a)">
      <path
        fill="#263E6A"
        fillRule="evenodd"
        d="M.438 2.32h1.1v1.11c0 .223.18.404.4.404s.4-.18.4-.404V2.32h1.1c.222 0 .4-.18.4-.403a.4.4 0 0 0-.4-.403h-1.1V.404a.4.4 0 0 0-.4-.403c-.22 0-.4.18-.4.403v1.11h-1.1c-.22 0-.4.18-.4.403s.18.404.4.404m21.03 1.225h.6v.605c0 .223.18.403.4.403.222 0 .401-.18.401-.403v-.605h.6c.22 0 .4-.181.4-.404a.4.4 0 0 0-.4-.403h-.6v-.605a.4.4 0 0 0-.4-.404c-.22 0-.4.18-.4.404v.605h-.6c-.221 0-.4.18-.4.403s.179.404.4.404m2.514 5.902a.3.3 0 0 1-.014.047q0 .003-.002.006-.006.015-.016.026l-.02.032q-.007.015-.018.028l-11.6 14.266-.001.001-.001.001-.002.002a.4.4 0 0 1-.057.056l-.009.007-.006.003-.008.006-.047.029-.032.013-.005.002-.006.002-.007.003-.008.004h-.003l-.003.002-.006.001-.006.001a.4.4 0 0 1-.1.015h-.009a.4.4 0 0 1-.107-.016l-.004-.001-.003-.002-.018-.007-.007-.003h-.003l-.03-.013a.4.4 0 0 1-.054-.033l-.009-.006-.004-.003-.004-.003a.4.4 0 0 1-.06-.06h-.001l-8.563-10.53a.406.406 0 0 1 .056-.568.4.4 0 0 1 .563.056l7.292 8.967L7.437 9.734H.4a.4.4 0 0 1-.205-.059L.19 9.672l-.007-.004a.4.4 0 0 1-.086-.078L.09 9.584A.4.4 0 0 1 .037 9.5v-.002l-.001-.003a.4.4 0 0 1-.03-.097l-.001-.019v-.007l-.002-.014L0 9.331l.002-.025.004-.04A.4.4 0 0 1 .04 9.16a.4.4 0 0 1 .056-.09l3.4-4.035a.4.4 0 0 1 .305-.143h16.402c.118 0 .229.052.305.143l3.4 4.034.017.027.01.015.01.016q.012.015.02.031l.002.005q.009.021.014.044l.004.015.005.017.009.033q.003.018.001.037v.035q.002.02 0 .04l-.008.032zm-7.4-.52h6.156l-2.72-3.228H15.78zm-.826 0-.8-3.228h-5.91l-.8 3.228zm-3.761 13.252 3.602-12.445H8.272zM8.222 5.7H3.985l-2.72 3.228h6.157zm8.208 4.035-3.496 12.08 9.824-12.08z"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="exklusivleistungen_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgExklusivleistungen;
